import React  from 'react'
import { Modal } from 'react-bootstrap'
import { CancelButton } from 'components'
import { ModalHeader, ModalBody } from './style'

const ModalDialog = (
  {
    children,
    title,
    subtitle,
    actionButton,
    onHide,
    variant = 'info',
    cancelText,
    hideSubtitle,
    ...rest
  },
) => {
  return (
    <Modal onHide={onHide} {...rest}>
      {
        title &&
        <ModalHeader closeButton>
          {title}
        </ModalHeader>
      }
      {
        !hideSubtitle && (
          subtitle ||
          <div className="px-3 small-font font-weight-lighter mt-1">
            Questions ? Problems ? View
            <a href=""> Instructions and more information</a>
          </div>
        )
      }

      <ModalBody variant={variant} className="font-weight-lighter">
        {children}
      </ModalBody>

      <Modal.Footer className="mx-auto border-0 mt-0 pt-0">
        {actionButton}
        <CancelButton onClick={() => onHide()}>{cancelText}</CancelButton>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalDialog
